export const Regex = {
    numberPattern: /^[0-9]*$/,
    alphabetAndSpacePattern: /^[\w ]*$/,
    alphabetPattern: /^[\w]*$/,
    swiftCodePattern: /\w*[a-zA-Z]\w*/,
    eightDigitPattern: /^[0-9]{8}$/,
    sixDigitPattern: /^[0-9]{6}$/,
    nineDigitPattern: /^[0-9]{9}$/,
    nonSwiftCharacters: `([A-Za-z0-9\-+?:().,'/ ]+)`,
    firstNameLastName: /^[a-zA-Z]+ [a-zA-Z]+$/,
    newLine: `([\r\n]+)`,
    swiftAndSquareBracket: /^[A-Za-z0-9\[\]\-+?:().,'/ ]+$/,
    // Safe characters can contain characters (A-Z, a-z, 0-9, dash -,  apostrophe ', space, comma and fullstop), no special characters
    safeCharacters: `([A-Za-z0-9\-' ,.]+)`,
    // Phone characters can contain characters (0-9, plus +, space), no special characters
    phoneCharacters: `([0-9\+ ]+)`,
};
